module.exports = __webpack_public_path__ + "img/bb_g1_t_mouth-06.3d6c46cb.svg";